import { API } from "aws-amplify";
import axios from 'axios';
import 'containers/common/Detail.css';
import SLMLeaseList from "containers/slm/SLMLeaseList";
import SLMSaleList from "containers/slm/SLMSaleList";
import RefreshButton from "components/RefreshButton";

import React, { Component } from "react";
import { Alert, Button, Card, Col, Form, Row, Tab, Tabs, Nav, Modal } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import { PacmanLoader } from 'react-spinners';
import { LinkContainer } from "react-router-bootstrap";
import Select from 'react-select';
import Moment from "moment";
import AsyncSelect from 'react-select/async';



const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default class SLMAddressDetail extends Component {
    constructor(props) {
        super(props);

        this.updateTableState = this.updateTableState.bind(this);
        this.saveRecord = this.saveRecord.bind(this); 
          
        this.refreshDataSet = this.refreshDataSet.bind(this);  
        this.validateRelatedRecord = this.validateRelatedRecord.bind(this);

        this.updateIntegrations = this.updateIntegrations.bind(this);

        this.state = {
            isLoading: null,
            isDeleting: null,
            address: null,
            saleFilter: { addressid: this.props.match.params.id },
            leaseFilter: { addressid: this.props.match.params.id },
            modified: false,
            showAlert: false,
            errorMessage: "",
            inputValue: "",
            idList: [],
            previousId: null,
            nextId: null,
            currentIdIndex: null,

            showAddressMatchingDialog: false,

            lease_id: null,
            sale_id: null,

            sales: [],
            leases: [],

            selectedSuburb: null,
            suburbOptions: [],

            selectedState: null,
            stateOptions: [],
            selectedExtension: null,
            selectedCornerExtension: null,
            selectedUnitType: null,

            address_id: null,
            address_key: null,
            hard_sequence: null,
            building_name: null,
            building_key: null,
            street_address_full: null,
            street_address: null,
            origin_street_address: null,
            floor_unit: null,
            floor_unit_type: null,
            street_no_low: null,
            street_no_low_suffix: null,
            street_no_high: null,
            street_no_high_suffix: null,
            street_name: null,            
            extension: null,
            extension_label: null,
            corner_street_name: null,            
            corner_extension: null,
            corner_extension_label: null,
            suburb: null,
            suburb_id: null,
            state_code: null,
            postcode: null,
            sub_region_name: null,
            region_name: null,
            cityscope_reference: null,
            lot_plan: null,
            title_reference: null,            

            created_date: null,
            created_by: null,
            last_edited_date: null,
            last_edited_by: null,
            archived_date: null
           
        };
                      

    }
    
     
    async componentWillReceiveProps(prevProps) {
        
        if (prevProps.location.pathname !== this.props.location.pathname) {
            // Clean component and reload? 
            console.log("Resetting");
            window.location.reload();
            
            
        }
    }
    componentWillUnmount() {
        console.log("slmaddress component unmounting");
        source.cancel();
        this.setState({ address: [], suburbOptions: [], agentOptions: [],sales: [],leases: [] });        
        
        }

    async componentDidMount() {
        try {
            this.setState({ isLoading: true });

            if (this.props.match.params.id == "new") {
                console.log("New address");

                this.setState(state => ({ created_date: new Date() }));
                this.setState(state => ({ created_by: this.props.user }));
                await this.syncroniseState();
                document.title = "New address record";
            }
            else {
                await this.retrieveAddress();
                if (this.props.location.state){
                    if (this.props.location.state.hasOwnProperty("data")){
                        const idList = this.props.location.state.data;
                        const currentIdIndex = idList.indexOf(parseInt(this.props.match.params.id,10));
                        
                        let nextId = null;
                        let previousId = null;
                        
                        if (currentIdIndex+1 < idList.length){
                            nextId = idList[currentIdIndex+1];
                            
                        }
                        if (currentIdIndex >0){
                            previousId = idList[currentIdIndex-1];                            
                        }
                        this.setState({idList: idList,nextId: nextId, previousId: previousId, currentIdIndex: currentIdIndex});
                    }
                    if (this.props.location.state.hasOwnProperty("lease_id")){
                        this.setState({lease_id: this.props.location.state.lease_id});
                    }
                    if (this.props.location.state.hasOwnProperty("sale_id")){
                        this.setState({sale_id: this.props.location.state.sale_id});
                    }

                }
                try {
                    this.state.address && this.getSales(this.state.saleFilter);
                }
                catch{
                    alert("Error loading sales");
                }

                try {
                    this.state.address && this.getLeases(this.state.leaseFilter);
                }
                catch{
                    alert("Error loading leases");
                }

                if (this.props.location.search.indexOf("browselist")>0) {
                    const idList = this.props.location.search.replace("?browselist=","").split(",").map(i => parseInt(i))
                    const currentIdIndex = idList.indexOf(parseInt(this.props.match.params.id));
                    
                    let nextId = null;
                    let previousId = null;
                    
                    if (currentIdIndex+1 < idList.length){
                        nextId = idList[currentIdIndex+1];
                        
                    }
                    if (currentIdIndex >0){
                        previousId = idList[currentIdIndex-1];                            
                    }
                    this.setState({idList: idList,nextId: nextId, previousId: previousId, currentIdIndex: currentIdIndex});
                }

                document.title = this.state.street_address_full
            }
            
            
            
            this.setState({ selectedState: { value: this.state.state_code, label: this.state.state_code } });
            
                        
            this.setState({selectedExtension: {value: this.state.extension , label: this.state.extension_label}});
            this.setState({selectedCornerExtension: {value: this.state.corner_extension , label: this.state.corner_extension_label}});

            
            let unitTypeLabel = this.state.floor_unit_type;
            if(this.props.unitTypes.filter(f=>f.value == this.state.floor_unit_type).length>0){
                unitTypeLabel = this.props.unitTypes.filter(f=>f.value == this.state.floor_unit_type)[0].label;
            }
            this.setState({selectedUnitType: {value: this.state.floor_unit_type , label: unitTypeLabel}});

            
            this.getStates({});
            if (this.state.state_code){
                this.setState({ selectedSuburb: { value: this.state.suburb_id, label: this.state.suburb+" "+ this.state.postcode } });
                this.getSuburbs({state: this.state.state_code});
            }
            
            this.setState({ isLoading: false });

        } catch (e) {
            alert(e);
        }
    }

    async syncroniseState() {

        const address = {
            address_id: this.state.address_id,
            address_key: this.state.address_key,
            hard_sequence: this.state.hard_sequence,
            building_name: this.state.building_name,
            building_key: this.state.building_key,
            street_address_full: this.state.street_address_full,
            street_address: this.state.street_address,
            origin_street_address: this.state.origin_street_address,
            floor_unit: this.state.floor_unit,
            floor_unit_type: this.state.floor_unit_type,
            street_no_low: this.state.street_no_low,
            street_no_low_suffix: this.state.street_no_low_suffix,
            street_no_high: this.state.street_no_high,
            street_no_high_suffix: this.state.street_no_high_suffix,
            street_name: this.state.street_name,
            extension: this.state.extension,
            extension_label: this.state.extension_label,
            corner_street_name: this.state.corner_street_name,
            corner_extension: this.state.corner_extension,
            corner_extension_label: this.state.corner_extension_label,
            suburb: this.state.suburb,
            suburb_id: this.state.suburb_id,
            state_code: this.state.state_code,
            postcode: this.state.postcode,
            sub_region_name: this.state.sub_region_name,
            region_name: this.state.region_name,
            cityscope_reference: this.state.cityscope_reference ,
            lot_plan: this.state.lot_plan ,
            title_reference: this.state.title_reference ,  
            created_date: this.state.created_date,
            created_by: this.state.created_by,
            last_edited_date: this.state.last_edited_date,
            last_edited_by: this.state.last_edited_by,
            archived_date: this.state.archived_date

        };

        this.setState({ address });

    }

    async retrieveAddress() {

        const address = await this.getAddress();

        const { address_id,
            address_key,
            hard_sequence,
            building_name,
            building_key,
            street_address_full,
            street_address,
            origin_street_address,
            floor_unit,
            floor_unit_type,
            street_no_low,
            street_no_low_suffix,
            street_no_high,
            street_no_high_suffix,
            street_name,
            extension,
            extension_label,
            corner_street_name,
            corner_extension,
            corner_extension_label,
            suburb,
            suburb_id,
            state_code,
            postcode,
            sub_region_name,
            region_name,
            cityscope_reference,
            lot_plan,
            title_reference ,  
            created_date,
            created_by,
            last_edited_date,
            last_edited_by,
            archived_date } = address;

        this.setState({
            address,
            address_id,
            address_key,
            hard_sequence,
            building_name,
            building_key,
            street_address_full,
            street_address,
            origin_street_address,
            floor_unit,
            floor_unit_type,
            street_no_low,
            street_no_low_suffix,
            street_no_high,
            street_no_high_suffix,
            street_name,
            extension,
            extension_label,
            corner_street_name,
            corner_extension,
            corner_extension_label,
            suburb,
            suburb_id,
            state_code,
            postcode,
            sub_region_name,
            region_name,
            cityscope_reference,
            lot_plan,
            title_reference , 
            created_date,
            created_by,
            last_edited_date,
            last_edited_by,
            archived_date
        });
    }

    //Call API
    async getAddress(filter) {
        try {
            const response = API.get("colin", `/slmaddresses/${this.props.match.params.id}`, { 'queryStringParameters': filter , 'cancelToken': source.token});
            try {
                return await response;
    
            } catch (error) {
                alert(error+". Please refresh the page (F5) to try again.")
            };
        }
        catch{
            console.log("Error getting the address");
        }

    } 
    async saveAddress(address, hideError = false) {
        
        this.setState({ last_edited_by: this.props.user });
        if (this.props.match.params.id === "new" && this.state.address_id === null) {
            this.setState({ created_by: this.props.user });
            const response =  await API.post("colin", `/slmaddresses/new`, { body: address });
            try {
                const response2 =  await response;
                
                return response2
    
            } catch (error) {
                if (hideError) {
                    console.warn(error);
                    return;
                }
                alert(error+". Please refresh the page (F5) to try again.")
            };
        }
        const response =  API.put("colin", `/slmaddresses/${this.state.address_id}`, { body: address  });
        try {
            const response2 =  await response;

            return response2

        } catch (error) {
            if (hideError) {
                console.warn(error);
                return;
            }
            alert(error+". Please refresh the page (F5) to try again.")
        };
    }

    async updateIntegrations() {
        try {
            this.saveAddress(this.state.address, true);
        } catch (error) {
            console.error(error);
        }
    }

    
    
    getSales(filter) {
        try {
            API.get("colin", "/slmsales" , { 'queryStringParameters': filter, 'cancelToken': source.token  }).then((sales) => {
                if (sales) {
                    this.setState(state => ({ sales }));
                }
            }
            );
        }
        catch{
            console.log("Error getting sales");
        }
    
    }

    getLeases(filter) {
        try {
            API.get("colin", "/slmleases" , { 'queryStringParameters': filter, 'cancelToken': source.token  }).then((leases) => {
                if (leases) {
                    this.setState(state => ({ leases }));
                }
            }
            );
        }
        catch{
            console.log("Error getting leases");
        }
    
    }
    

    getStates(filter) {
        try {
            API.get("colin", `/slmstates`, { 'queryStringParameters': filter, 'cancelToken': source.token }).then((stateOptions) => {
                if (stateOptions) {
                    this.setState(state => ({ stateOptions }));
                }
            });
        }
        catch{
            console.log("Error getting states");
        }
    }

    getSuburbs(filter) {
        try {
            API.get("colin", `/slmsuburbs`, { 'queryStringParameters': filter, 'cancelToken': source.token }).then((suburbOptions) => {
                if (suburbOptions) {
                    this.setState(state => ({ suburbOptions }));
                }
            });
        }
        catch{
            console.log("Error getting suburbs");
        }
    }

    refreshDataSet = async (dataset) => {
        //Get nabers records
        console.log("Inside refresh dataset");
        switch (dataset) {
            case "sales":
                try {
                    await this.getSales(this.state.saleFilter);
                }
                catch{
                    alert("Error loading sales");
                }
                case "leases":
                try {
                    await this.getLease(this.state.leaseFilter);
                }
                catch{
                    alert("Error loading leases");
                }
            
        }
    }

    validateRelatedRecord(record, set) {
        //address
        if (set === "address") {

            
            if (this.state.street_name === null ) {
                return [false, "You must enter a street name"];
            }

            if (this.state.extension === null ) {
                return [false, "You must enter a street extension"];
            }
            
            if (this.state.suburb_id === null ) {
                return [false, "You must select a state then suburb"];
            }

            if (parseInt(this.state.street_no_low) > parseInt(this.state.street_no_high||9999999) ) {
                return [false, "Street number low cannot be greater than street number high"];
            }


        }

        



        return [true,""];
    }

    updateTableState(data, set) {

        this.setState({
            [set]: data
        });
    }




    saveRecord(record, endpoint, id) {

        record.last_edited_by = this.props.user;
        //If the record is a new record perform a post
        if (record.hasOwnProperty("new_record")) {
            if (record.new_record === true) {
                record.last_edited_by = this.props.user;

                return API.post("colin", `/slm${endpoint.toLowerCase()}/new`, {
                    body: record
                });
                
            }
        }
        //If not a new record and updating an existing, perform a put
        //First condition looks after many to many relationships

        return API.put("colin", `/slm${endpoint.toLowerCase()}/${record[id]}`, {
            body: record
        });
        


    }

    handleEnterCurrentIdIndex = event =>{
        if(event.keyCode === 13 || event.keyCode === 9 ){
           this.handleGoToRecord();
        }
   }

    handleGoToRecord = event => {
        console.log(this.state.idList.length);
        if(this.state.currentIdIndex>=0 && this.state.currentIdIndex < this.state.idList.length){
            this.props.history.push({pathname:`/slmaddresses/${this.state.idList[this.state.currentIdIndex]}`, state:{data: this.state.idList}});
        }
        else{
            alert("Page no not in range.");
        }
    }

    handleCurrentIdIndexChange =event =>{
        const val = event.target.value.replace(/[^0-9.]/g, "");
        this.setState({[event.target.id]: val-1});        
    }

    handleChange = event => {
        
        if(event.target.id==="extension"){

            this.setState({ [event.target.id]: event.target.value.substring(0,2).toUpperCase().replace(/[^A-Z]/g, "") });
        }
        else if (event.target.id==="floor_unit"){
            this.setState({ [event.target.id]: event.target.value.substring(0,5) });
        }
        else{
            this.setState({ [event.target.id]: event.target.value });
        }
        this.setState({ modified: true });

    }


    handleDateChange(date, name) {
        var options = {  year: 'numeric', month: 'long', day: 'numeric' };
        var dt = new Date(date);
        
        if (date) {
            this.setState({
                [name]: dt.toLocaleDateString('en-AU',options)
                , modified: true
            });
        }
        this.setState({ modified: true });
    }


    handleCheckBoxChange = event => {

        let name = event.target.name
        this.setState({
            [name]: event.target.checked
        })
        this.setState({ modified: true });

    }

    handleSuburbChange = (selectedSuburb) => {
        this.setState({ selectedSuburb });
        this.setState({ modified: true, suburb_id: selectedSuburb.value, suburb: selectedSuburb.label, state_code: selectedSuburb.state_code, postcode: selectedSuburb.postcode, region_name: selectedSuburb.region_name, sub_region_name: selectedSuburb.sub_region_name },this.handleBlur);
      
    }

    handleStateChange = (selectedState) => {
        this.getSuburbs({state: selectedState.value});
        this.setState({ selectedState });
        this.setState({ state_code: selectedState.value, modified: true, selectedSuburb: null });
        
    }
    handleExtensionChange = (selectedExtension) => {
        if(selectedExtension){
        this.setState({ selectedExtension });
        this.setState({ extension: selectedExtension.value, modified: true });
        }else{
            this.setState({ selectedExtension: {value: null, label: null} });
            this.setState({ extension: null, modified: true });
        }
    }
    handleCnrExtensionChange = (selectedCornerExtension) => {
        if(selectedCornerExtension){
        this.setState({ selectedCornerExtension });
        this.setState({ corner_extension: selectedCornerExtension.value, modified: true });
    }else{
        this.setState({ selectedCornerExtension: {value: null, label: null} });
        this.setState({ corner_extension: null, modified: true });
    }
    }

    handleUnitTypeChange = (selectedUnitType) => {
        
        if(selectedUnitType){            
        this.setState({ selectedUnitType });
        this.setState({ floor_unit_type: selectedUnitType.value, modified: true });
        }
        else{            
            this.setState({ selectedUnitType:{value: null, label: null} });
            this.setState({ floor_unit_type: null, modified: true });
        }
        
    }


    handleBlur = async event => {
        
        if (this.state.modified === true) { 
            

            if(event){ 
                console.log(event.target.id);
                if(event.target.id==="street_no_low" && (this.state.street_no_high==null || this.state.street_no_high=="")){
                    this.setState({ street_no_high: this.state.street_no_low });    
                }

                if(event.target.id==="floor_unit" && this.state.floor_unit){
                    alert("Important: Unit Numbers entered here MUST be strata unit numbers only. Floor levels or Suite numbers MUST NOT be entered in this field!");
                }    
            }      
            this.setState({ showAlert: false, last_edited_by: this.props.user });
            const result = await this.syncroniseState();
            const validation = this.validateRelatedRecord(this.state.address, "address");
            if (validation[0] === true) {
                if(validation[1]!==""){
                    this.setState({ errorMessage: validation[1] });
                    this.setState({ showAlert: true });
                }
                try {
                    this.setState(state => ({ modified: false }));
                    if (this.props.match.params.id === "new") {
                        this.setState({ isLoading: true });
                    }
                    
                    const result2 = await this.saveAddress(this.state.address);
                    await result2;
                    console.log(result2);
                    this.setState({ isLoading: false });
                    
                    if (result2.result === false) {
                        
                        alert(result2.error_message);
                    }
                    else {
                       
                        if (this.props.match.params.id === "new") {
                            this.setState(state => ({ address_id: result2.id }));                            
                            this.props.history.push("/slmaddresses/" + result2.id);
                        }
                        // else{
                        //     this.setState({street_address: result.error_message});
                        // }
                    }
                } catch (e) {
                    alert(e);
                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
            }
        }
    }



    

    handleDelete = async event => {
        event.preventDefault();

        if (event.detail !== 0) {
            const confirmed = window.confirm(
                "Are you sure you want to delete this address?"
            );

            if (!confirmed) {
                return;
            }
            this.setState({ archived_date: new Date() });
            await this.syncroniseState();


            const result = await this.saveAddress(this.state.address);
            if (result.result === false) {
                alert(result.error_message);
            }
            else {

                this.props.history.push("/");
            }
        }
    }

    
    loadOptions = async (inputValue) => {
        if (inputValue.length>=3){
        return await API.get("colin", `/slmsuburbs`, { 'queryStringParameters': {suburb: inputValue}, 'cancelToken': source.token });
        }
        else{
            return [];
        }

    }

    handleInputChange = (newValue) => {
        const inputValue = newValue; //.replace(/\W/g, '+');
        this.setState({ inputValue });
        return inputValue;
    };

    render() {
        return (
            <div className="Address">
                {this.state.isLoading &&
                    <div className="outer-div"><div className='sweet-loading inner-div' >
                        <PacmanLoader
                            css="display: block;
                            margin: 0 auto;
                             border-color: red"
                        sizeUnit={"px"}
                        size={20}
                        color={'#e03c31'}
                        loading={this.state.isLoading}
                        />
                </div>
                    </div>}
                {this.state.address && this.props.streetTypes.length>0 &&this.props.isAuthenticated && !this.state.isLoading &&
                    <Form  >
                         <Modal show={this.state.showAlert && this.state.address_id? true: false} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                                <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                                <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                            </Modal>
                            {this.state.showAlert && !this.state.address_id &&
                            <Alert variant="danger">{this.state.errorMessage}</Alert>
                            }

                        <Form.Row>
                            <Col sm={12} md={8} lg={8} > 
                                <h6>
                                Address Details - {(this.state.building_name || "")} | {(this.state.street_address || "")} {(this.state.suburb || "")} {(this.state.state_code || "")} {(this.state.postcode || "")} {this.state.archived_date &&  <font color="red"> || *** ARCHIVED ***</font>}
                                </h6>
                            </Col>
                            <Col>
                                <Nav className="justify-content-center " >
                                {this.state.previousId!== null && this.state.idList.length>0 &&
                                    <Nav.Item  >
                                        <LinkContainer to={{pathname:`/slmaddresses/${this.state.previousId}`, state:{data: this.state.idList}}} >
                                            <Button type="button" variant="info"  size="sm">Previous</Button></LinkContainer>{" "}
                                    </Nav.Item>}
                                   
                                    {this.state.nextId!== null && this.state.idList.length>0 &&
                                    <Nav.Item  >
                                        <LinkContainer to={{pathname:`/slmaddresses/${this.state.nextId}`, state:{data: this.state.idList}}} >
                                            <Button type="button" variant="info"  size="sm">Next</Button></LinkContainer>{" "}
                                    </Nav.Item>}
                                    {this.state.currentIdIndex!==null && this.state.idList.length>0 &&
                                        <Form.Group as={Row} controlId="currentIdIndex" >     
                                        <Col className="zeroPadRight">
                                            <Form.Control
                                                onChange={this.handleCurrentIdIndexChange}
                                                value={this.state.currentIdIndex+1}
                                                as="input"
                                                type="text"
                                                min="0"
                                                className="pageCount"
                                                onBlur={this.handleGoToRecord}
                                                onKeyDown={this.handleEnterCurrentIdIndex}
                                            />
                                            </Col>                               
                                            <Col  className="zeroPadLeft">
                                            <h6><div className="topPad">of {this.state.idList.length} {" "}</div></h6>
                                            </Col>
                                            
                                        </Form.Group>
                                         
                                    }
                                    </Nav>
                                </Col>
                            
                            <Col >
                             <Nav className="justify-content-end " >                             
                                <Nav.Item  >  
                                <a href={`/slmaddresses`}><Button variant="primary" size="sm" type="button" >Back to Address Search</Button></a>{" "} 
    {this.state.lease_id &&<a href={`/slmleases/${this.state.lease_id}`}><Button variant="primary" size="sm" type="button" >Back to Lease {this.state.lease_id}</Button></a>}
    {this.state.sale_id &&<a href={`/slmsales/${this.state.sale_id}`}><Button variant="primary" size="sm" type="button" >Back to Sale {this.state.sale_id}</Button></a> }                           
                                {/* <Button  variant="danger" type="button"  onClick={this.handleDelete} size="sm" >Delete Address</Button> */}
                                </Nav.Item>
                            </Nav> 
                            </Col>


                        </Form.Row>
                        {this.state.address_id &&
                        <Form.Row>
                            <Col lg={1}></Col>
                            <Col><font color="red"> Please Note: Edits made to this address will apply to ALL transactions linked to this address</font></Col>
                        </Form.Row>
                        }

                    

                        <Row>
                            <Col sm={6} md={6} lg={3}>
                                    <Form.Row>     
                                        <Col > &nbsp; </Col>
                                    </Form.Row>
                                   <Form.Row>     
                                   <Col >   
                                
                                        <Form.Group as={Row} >
                                        <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>CoLin ID</Form.Label>
                                        <Col style={{"padding-right": 5}}>
                                               <Form.Control
                                                disabled
                                                readOnly
                                                onChange={this.handleChange}
                                                value={this.state.address_id}
                                                type="text"
                                                id="address_id"
                                                onBlur={this.handleBlur}
                                                style={{"padding-right": 5}}
                                               />
                                        </Col>
                                        
                                        <Form.Label as={Col} className="text-right" column sm={4} md={4} lg={2} style={{"padding-right": 1, "padding-left": 1}}>PIMs ID</Form.Label>
                                        <Col sm={4} md={3} lg={3} style={{"padding-left": 5}}>
                                               <Form.Control
                                                disabled
                                                readOnly
                                                onChange={this.handleChange}
                                                value={this.state.hard_sequence}
                                                type="text"
                                               // id="address_id"
                                                onBlur={this.handleBlur}
                                               />
                                        </Col>
                                        </Form.Group>

                                    <Form.Group as={Row} controlId="building_name">
                                        <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Building Name</Form.Label>
                                        <Col>
                                        <Form.Control
                                            onChange={this.handleChange}
                                            value={this.state.building_name}
                                            type="text"
                                                onBlur={this.handleBlur}
                                        />
                                        </Col>

                                    </Form.Group>   
{/*                                     
                                    <Form.Group as={Row} controlId="floor_unit_type">
                                      
                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Unit Describer</Form.Label>
                                            <Col>
                                                
                                                <Select
                                                    value={this.state.selectedUnitType}
                                                    onChange={this.handleUnitTypeChange}
                                                    options={this.props.unitTypes}                                                    
                                                    onBlur={this.handleBlur}
                                                    isClearable
                                                />
                                            </Col>
                                            
                                            
                                    </Form.Group>

                                    <Form.Group as={Row} controlId="floor_unit">
                                      
                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Unit Number</Form.Label>
                                            <Col>
                                                <Form.Control
                                                    onChange={this.handleChange}
                                            value={this.state.floor_unit}
                                                    type="text"
                                                onBlur={this.handleBlur}
                                                />
                                            </Col>
                                            
                                            
                                    </Form.Group> */}
                                  <Row><Col sm={6} md={6} lg={4}></Col><Col></Col></Row>
                                    <Form.Group as={Row}>
                                        <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Street Number Low</Form.Label>
                                        <Col sm={6} md={6} lg={5}>
                                        <Form.Control
                                            onChange={this.handleChange}
                                            value={this.state.street_no_low}
                                            id="street_no_low"
                                            type="text"
                                                onBlur={this.handleBlur}
                                        />
                                    </Col>
                                    <Col>
                                        <Form.Control
                                            onChange={this.handleChange}
                                            value={this.state.street_no_low_suffix}
                                            id="street_no_low_suffix"
                                            type="text"
                                                onBlur={this.handleBlur}
                                        />
                                    </Col>
                                    </Form.Group>
                                    <Form.Group as={Row}>
                                    <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Street Number High</Form.Label>
                                            <Col sm={6} md={6} lg={5}>
                                                <Form.Control
                                                    onChange={this.handleChange}
                                                value={this.state.street_no_high}
                                                    type="text"
                                                    id="street_no_high"
                                                onBlur={this.handleBlur}
                                                />
                                                </Col>
                                                <Col>
                                                <Form.Control
                                                    onChange={this.handleChange}
                                                value={this.state.street_no_high_suffix}
                                                    type="text"
                                                    id="street_no_high_suffix"
                                                onBlur={this.handleBlur}
                                                />
                                                </Col>
                                
                                
                                        </Form.Group>

                                        <Form.Group as={Row} controlId="street_name">
                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Street Name</Form.Label>
                                            <Col>
                                                <Form.Control
                                                    onChange={this.handleChange}
                                                value={this.state.street_name}
                                                    type="text"
                                                onBlur={this.handleBlur}
                                                />
                                            </Col>
                                            
                                        </Form.Group>
                                        <Row><Col sm={6} md={6} lg={4}></Col><Col>Note: Street Name MUST exclude Street Extension</Col></Row>
                                        <Form.Group as={Row} controlId="extension">
                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Street Extension</Form.Label>
                                            <Col  sm={6} md={6} lg={5}>
                                                
                                                <Select
                                                    value={this.state.selectedExtension}
                                                    onChange={this.handleExtensionChange}
                                                    options={this.props.streetTypes}                                                    
                                                    onBlur={this.handleBlur}
                                                    isClearable
                                                />
                                            </Col>

                                            <Col  >
                                                
                                            <Form.Control
                                                    value={this.state.selectedExtension.value}
                                                    as="input"
                                                    type="text"
                                                    readOnly
                                                />
                                            </Col>
                                        </Form.Group>

                                        <Form.Row><Col>{" "}</Col></Form.Row>
                                        
                                        <Form.Group as={Row} controlId="corner_street_name">
                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>cnr Street Name</Form.Label>
                                            <Col>
                                                <Form.Control
                                                    onChange={this.handleChange}
                                                value={this.state.corner_street_name}
                                                    type="text"
                                                onBlur={this.handleBlur}
                                                />
                                            </Col>
                                            
                                        </Form.Group>
                                        <Row><Col sm={6} md={6} lg={4}></Col><Col>Note: Street Name MUST exclude Street Extension</Col></Row>
                                        <Form.Group as={Row} controlId="corner extension">
                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>cnr Street Extension</Form.Label>
                                            <Col   sm={6} md={6} lg={5}>
                                                
                                                <Select
                                                    value={this.state.selectedCornerExtension}
                                                    onChange={this.handleCnrExtensionChange}
                                                    options={this.props.streetTypes}                                                    
                                                    onBlur={this.handleBlur}
                                                    isClearable
                                                />
                                            </Col>
                                       
                                            
                                            <Col  >
                                                
                                            <Form.Control
                                                    value={this.state.selectedCornerExtension.value}
                                                    as="input"
                                                    type="text"
                                                    readOnly
                                                />
                                            </Col>
                                        </Form.Group>

                                        <Form.Group as={Row} controlId="street_address">
                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Display Address</Form.Label>
                                            <Col>
                                                <Form.Control
                                                    disabled
                                                value={this.state.street_address}
                                                    type="text"
                                                
                                                />
                                            </Col>
                                            
                                        </Form.Group>
                                        <Form.Group as={Row} controlId="suburb" >
                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Suburb</Form.Label>
                                            <Col>
                                                {/* <Select
                                                    value={this.state.selectedSuburb}
                                                    onChange={this.handleSuburbChange}
                                                    options={this.state.suburbOptions}
                                                    onInputChange={this.handleInputChange}
                                                    onBlur={this.handleBlur}
                                                    isDisabled={this.state.state_code ? false : true}
                                                /> */}
                                                <AsyncSelect
                                                // cacheOptions
                                                    loadOptions={this.loadOptions}
                                                    value={this.state.selectedSuburb}
                                                    onChange={this.handleSuburbChange}
                                                //  defaultOptions
                                                    onInputChange={this.handleInputChange}
                                                />
                                            </Col>

                                        </Form.Group>
                                        <Form.Group as={Row} controlId="state_code" >
                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>State</Form.Label>
                                            <Col>
                                            {/* <Select
                                                    value={this.state.selectedState}
                                                    onChange={this.handleStateChange}
                                                    options={this.state.stateOptions}
                                                    onInputChange={this.handleInputChange}
                                                    onBlur={this.handleBlur}
                                                    
                                                /> */}

                                                <Form.Control
                                                    onChange={this.handleChange}
                                                    value={this.state.state_code}
                                                    as="input"
                                                    type="text"
                                                    readOnly
                                                />


                                            </Col>

                                        </Form.Group>
                                        
                                        <Form.Group as={Row} controlId="postcode" >
                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Postcode</Form.Label>
                                            <Col>
                                                <Form.Control
                                                    onChange={this.handleChange}
                                                    value={this.state.postcode}
                                                    as="input"
                                                    type="text"
                                                    readOnly
                                                />
                                            </Col>

                                        </Form.Group>

                                        <Form.Group as={Row} controlId="region_name" >
                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Statistical Division</Form.Label>
                                            <Col>
                                                <Form.Control
                                                    onChange={this.handleChange}
                                                    value={this.state.region_name}
                                                    as="input"
                                                    type="text"
                                                    readOnly
                                                />
                                            </Col>

                                        </Form.Group>

                                        { false &&
                                        <Form.Group as={Row} controlId="lot_plan" >
                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Lot Plan</Form.Label>
                                            <Col>
                                                <Form.Control
                                                    onChange={this.handleChange}
                                                    value={this.state.lot_plan}
                                                    as="input"
                                                    type="text"
                                                    onBlur={this.handleBlur}
                                                    
                                                />
                                            </Col>

                                        </Form.Group>
                                        }

                                        
                                        {/* <Form.Group as={Row} controlId="title_reference" >
                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Title Reference</Form.Label>
                                            <Col>
                                                <Form.Control
                                                    onChange={this.handleChange}
                                                    value={this.state.title_reference}
                                                    as="input"
                                                    type="text"
                                                    onBlur={this.handleBlur}
                                                />
                                            </Col>

                                        </Form.Group>

                                        <Form.Group as={Row} controlId="cityscope_reference" >
                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Cityscope Reference</Form.Label>
                                            <Col>
                                                <Form.Control
                                                    onChange={this.handleChange}
                                                    value={this.state.cityscope_reference}
                                                    as="input"
                                                    type="text"
                                                    onBlur={this.handleBlur}
                                                />
                                            </Col>

                                        </Form.Group> */}
                                        <Form.Group as={Row} controlId="origin_street_address" >
                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>SLM4 Street Address</Form.Label>
                                            <Col>
                                                <Form.Control
                                                    onChange={this.handleChange}
                                                    value={this.state.origin_street_address}
                                                    as="input"
                                                    type="text"
                                                    onBlur={this.handleBlur}
                                                    disabled
                                                />
                                            </Col>

                                        </Form.Group>

                                        <Form.Group as={Row} controlId="created_date" >
                                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>Created Date</Form.Label>
                                            <Col>
                                                <Form.Control
                                                    value={this.state.created_date!= null ? Moment(this.state.created_date)
                                                        .local()
                                                        .format("DD-MM-YYYY"): ""}
                                                    plaintext readOnly
                                                />
                                            </Col>
                                            <Col>
                                                <RefreshButton onClick={this.updateIntegrations} timeout={90000} size="sm" variant="secondary" type="button" />
                                            </Col>
                                        </Form.Group>

                                                <Form.Group as={Row} controlId="created_by" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Created By</Form.Label>
                                                    <Col>
                                                        <Form.Control
                                                            value={this.state.created_by}
                                                            plaintext readOnly
                                                        />
                                                    </Col>
                                                </Form.Group>

                                                <Form.Group as={Row} controlId="last_edited_date" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Last Edited Date</Form.Label>
                                                    <Col>
                                                        <Form.Control
                                                            value={this.state.last_edited_date!= null ? Moment(this.state.last_edited_date)
                                                                .local()
                                                                .format("DD-MM-YYYY"): ""}
                                                            plaintext readOnly
                                                        />
                                                    </Col>
                                                </Form.Group>

                                                <Form.Group as={Row} controlId="last_edited_by" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Last Edited By</Form.Label>
                                                    <Col>
                                                        <Form.Control
                                                            value={this.state.last_edited_by}
                                                            plaintext readOnly
                                                        />
                                                    </Col>
                                                </Form.Group>


                            
                            </Col>
                             </Form.Row>
                      
                            </Col>
                            <Col sm={6} md={6} lg={9}>
                                
                                <Form.Row>
                                    <Col>
                                        
                                        <SLMSaleList
                                            filter={this.state.saleFilter}
                                            isAuthenticated={this.props.isAuthenticated}
                                            controlType="table2"
                                            data={this.state.sales}
                                            updateTableState={this.updateTableState}
                                            saveRecord={this.saveRecord}
                                            deleteRecord={this.deleteRecord}
                                            addressid={this.state.address_id}
                                            hardsequence={this.state.hard_sequence}
                                            buildingname={this.state.building_name}
                                            floorunit={this.state.floor_unit}
                                            streetnolow={this.state.street_no_low}
                                            streetnohigh={this.state.street_no_high}
                                            streetname={this.state.street_name}
                                            extension={this.state.extension}
                                            suburb={this.state.suburb}
                                            statecode={this.state.state_code}
                                            postcode={this.state.postcode}
                                            validateRelatedRecord={this.validateRelatedRecord}
                                         /> 
                                    </Col>
                                </Form.Row>
                                <br/><br/>
                                <Form.Row>
                                    <Col>
                                    
                                        <SLMLeaseList
                                                filter={this.state.leaseFilter}
                                                isAuthenticated={this.props.isAuthenticated}
                                                controlType="table2"
                                                data={this.state.leases}
                                                updateTableState={this.updateTableState}
                                                saveRecord={this.saveRecord}
                                                deleteRecord={this.deleteRecord}
                                                addressid={this.state.address_id}
                                                validateRelatedRecord={this.validateRelatedRecord}
                                                hardsequence={this.state.hard_sequence}
                                                buildingname={this.state.building_name}
                                                floorunit={this.state.floor_unit}
                                                streetnolow={this.state.street_no_low}
                                                streetnohigh={this.state.street_no_high}
                                                streetname={this.state.street_name}
                                                extension={this.state.extension}
                                                suburb={this.state.suburb}
                                                statecode={this.state.state_code}
                                                postcode={this.state.postcode}
                                            />
                                    </Col>
                                </Form.Row>
                            </Col>
                        </Row>
 
                     
                    </Form>}
            </div>
        );
    }
}